var _rect, _path, _circle, _circle2, _circle3, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRobotActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    width: 16,
    height: 11,
    rx: 2,
    fill: "#6C65F7",
    fillOpacity: 0.16,
    stroke: "#6C65F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 8V5.5",
    stroke: "#6C65F7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 4.5,
    r: 1,
    fill: "#6C65F7",
    fillOpacity: 0.16,
    stroke: "#6C65F7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 13,
    r: 1.25,
    fill: "#6C65F7",
    fillOpacity: 0.16,
    stroke: "#6C65F7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 13,
    r: 1.25,
    fill: "#6C65F7",
    fillOpacity: 0.16,
    stroke: "#6C65F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 16.5H14.5",
    stroke: "#6C65F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 12H2M20 12H22",
    stroke: "#6C65F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobotActive);
export default __webpack_public_path__ + "static/media/robot-active.4246891803254f3e2525cae019d35751.svg";
export { ForwardRef as ReactComponent };